import { Field } from "@components/common/Field";
import { Agency } from "@gen/agency/v1/agency_pb";
import { Caisse, CaisseIdentity, Flexibility } from "@gen/caisse/v1/caisse_pb";

export const fields: (
  t: (s: string) => string,
  agencies: Agency[],
  caisseIds: CaisseIdentity[],
) => Field<Caisse>[] = (t, agencies, caisseIds) => [
  {
    key: "name",
    type: "text",
    label: t("name"),
    sortable: true,
  },
  {
    key: "id",
    type: "select",
    label: t("code"),
    searchPlaceholder: t("admin.caisse.code.searchPlaceholder"),
    display: (v) => v as number,
    options: caisseIds.map((caisse) => ({
      label: `${caisse.name} (${caisse.id})`,
      value: caisse.id,
    })),
    creation: {
      enabled: true,
      rules: {
        required: t("admin.caisse.code.required"),
      },
    },
    sortable: true,
  },
  {
    key: "agencyId",
    type: "select",
    label: t("admin.caisse.agencyConfiguration.label"),
    searchPlaceholder: t("admin.caisse.agencyConfiguration.searchPlaceholder"),
    options: agencies?.map((agency) => ({
      label: agency.alias,
      value: agency.id,
    })),
    editable: false,
    creation: {
      enabled: true,
      rules: {
        required: t("admin.caisse.agencyConfiguration.required"),
      },
    },
    sortable: true,
  },
  {
    key: "trainStationSearchRadiusKm",
    type: "number",
    label: t("admin.caisse.trainStationRadius.label"),
    header: t("admin.caisse.trainStationRadius.header"),
    editable: true,
    max: 200,
    min: 0,
    creation: {
      enabled: true,
      defaultValue: 20,
      rules: {
        required: t("admin.caisse.trainStationRadius.required"),
      },
    },
  },
  {
    key: "airportSearchRadiusKm",
    type: "number",
    label: t("admin.caisse.airportRadius.label"),
    header: t("admin.caisse.airportRadius.header"),
    editable: true,
    max: 200,
    min: 0,
    creation: {
      enabled: true,
      defaultValue: 30,
      rules: {
        required: t("admin.caisse.airportRadius.required"),
      },
    },
  },
  {
    key: "assistedTrainAgencyFeesEurCents",
    type: "number",
    label: t("admin.caisse.assistedTrainAgencyFees.label"),
    header: t("admin.caisse.assistedTrainAgencyFees.header"),
    editable: true,
    min: 0,
    creation: {
      enabled: true,
    },
  },
  {
    key: "assistedPlaneAgencyFeesEurCents",
    type: "number",
    label: t("admin.caisse.assistedPlaneAgencyFees.label"),
    header: t("admin.caisse.assistedPlaneAgencyFees.header"),
    editable: true,
    min: 0,
    creation: {
      enabled: true,
    },
  },
  {
    key: "assistedAgencyFeesVatPercent",
    type: "number",
    label: t("admin.caisse.assistedAgencyFeesVat.label"),
    header: t("admin.caisse.assistedAgencyFeesVat.header"),
    editable: true,
    min: 0,
    max: 100,
    creation: {
      enabled: true,
      rules: {
        min: {
          value: 0,
          message: t("admin.caisse.assistedAgencyFeesVat.range"),
        },
        max: {
          value: 100,
          message: t("admin.caisse.assistedAgencyFeesVat.range"),
        },
      },
    },
  },
  {
    key: "trainMinFlexibility",
    type: "select",
    label: t("admin.caisse.trainFlexibility"),
    options: [
      {
        label: "N/A",
        value: Flexibility.UNSPECIFIED,
      },
      {
        label: t("admin.caisse.noFlex"),
        value: Flexibility.NO_FLEX,
      },
      {
        label: t("admin.caisse.semiFlex"),
        value: Flexibility.SEMI_FLEX,
      },
      {
        label: t("admin.caisse.fullFlex"),
        value: Flexibility.FULL_FLEX,
      },
    ],
  },
  {
    key: "planeMinFlexibility",
    type: "select",
    label: t("admin.caisse.planeFlexibility"),
    options: [
      {
        label: "N/A",
        value: Flexibility.UNSPECIFIED,
      },
      {
        label: t("admin.caisse.noFlex"),
        value: Flexibility.NO_FLEX,
      },
      {
        label: t("admin.caisse.semiFlex"),
        value: Flexibility.SEMI_FLEX,
      },
      {
        label: t("admin.caisse.fullFlex"),
        value: Flexibility.FULL_FLEX,
      },
    ],
  },
];
